<script>
  import { onMount } from "svelte";

  import Header from "lib/components/Header.svelte";
  import { Accordion, SectionWrapper, TextInput, Button } from "paxray-components-svelte";
  import TechnologyRecommendation from "./components/technologyRecommendation.svelte";
  import SideKPI from "lib/components/sideKPI.svelte";
  import {
    DataTable,
    Pagination,
    Modal,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    DataTableSkeleton,
  } from "carbon-components-svelte";
  import PaxbotSidemenu from "lib/components/paxbot/paxbotSidemenu.svelte";
  import PaxbotBottomRight from "lib/components/paxbot/paxbotBottomRight.svelte";
  import RatingPoint from "./components/RatingPoint.svelte";
  import Select from "@components/common/forms/Select.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { DOWNLOAD_DARK_ICON, EDIT_ICON, SAVE_ICON } from '@utils/icons.js';

  export let analysisid;
  let appname;
  let rowId;
  let totalLicenses;
  let costUserYear;
  let type;

  let appnameOpenModal = false;
  let licencesOpenModal = false;
  let costUserYearOpenModal = false;
  let errorMessageLicences = "";
  let errorMessageCostUserYear = "";
  let rows = [];
  let firstLoad = true;
  let loading = true;

  let headers = [
    { key: "clearname", value: "App" },
    { key: "wastePerYear", value: "Savings/y" },
    { key: "usageScore", value: "Usage Score" },
    { key: "totalLicenses", value: "Licences" },
    { key: "costPerLicense", value: "Cost/User" },
    { key: "subscriptionType", value: "Type" },
    { key: "uniqueUsers", value: "Unique Users" },
    { key: "totalCostPerYear", value: "Total Cost/Year" },
    { key: "departments", value: "Department(s)" },
    { key: "edit", value: "Edit" },
  ];

  let paxbotWaste = getTop10WastefulApps(rows).toLocaleString();
  let selectedRowIds = [];
  let defaultSort = { key: "wastePerYear", order: "descending" };
  // @Adrian @Jonas do we have an endpoint where the unwanted apps are declared?
  let unwantedApps = ["Excel", "TextEdit", "Notepad"];

  let officeApps = [
    "Word",
    "Excel",
    "PowerPoint",
    "Outlook",
    "Access",
    "OneNote",
    "Publisher",
    "Visio",
    "Project",
    "Teams",
  ];

  //// Pagination

  let pageSize = 10;
  let page = 1;

  //// Paxbot

  let paxbotOpen = false;

  $: selectedRows = rows.filter((row) => selectedRowIds.includes(row.id));
  $: totalWaste = selectedRows
    .filter((row) => row !== "" && row.wastePerYear !== "")
    .reduce((sum, row) => sum + row.wastePerYear, 0)
    .toLocaleString("en-US");

  $: if (firstLoad && rows.length > 0) {
    selectedRowIds = rows.map((row) => row.id);
    firstLoad = false;
  }

  function getRows() {
    loading = true;
    fetchWithSession(`/api/analysis/licenseChecker/${analysisid}`)
      .then((response) => response.json())
      .then((data) => {
        rows = data.map((row, index) => {
          row.isEditing = false;
          if (!row.id) {
            row.id = `${row.applicationname}-${row.clearname}-${index}`;
          }
          if (firstLoad) {
            selectedRowIds = [...row.id];
          }
          return row;
        });
        loading = false;
      });
  }

  function createAppnameMapping(newData) {
    fetchWithSession(`/api/damprojects/createAppnameMapping`, {
      method: "POST",
      body: JSON.stringify(newData),
    })
      .then((response) => response.json())
      .then((data) => {
        getRows();
      });
  }

  function updateAppnameMapping(newData) {
    fetchWithSession(`/api/damprojects/saveAppnameMapping`, {
      method: "POST",
      body: JSON.stringify(newData),
    })
      .then((response) => response.json())
      .then((data) => {
        getRows();
      });
  }

  function saveAppnameMapping() {
    const currentRow = rows.find((row) => row.id === rowId);
    console.log(currentRow);
    const isValidUUID =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        currentRow.id
      );
    if (!isValidUUID) {
      const data = {
        applicationname: currentRow.applicationname,
        clearname: currentRow.clearname,
        totallicenses: parseInt(currentRow.totalLicenses) || 0,
        costperlicense: parseInt(currentRow.costPerLicense) || 0,
        subscriptiontype: currentRow.subscriptionType || "",
        apptype: currentRow.apptype || "",
      };
      createAppnameMapping(data);
    } else {
      const data = {
        id: currentRow.id,
        applicationname: currentRow.applicationname,
        clearname: currentRow.clearname,
        totallicenses: parseInt(currentRow.totalLicenses) || 0,
        costperlicense: parseInt(currentRow.costPerLicense) || 0,
        subscriptiontype: currentRow.subscriptionType || "",
        apptype: currentRow.apptype || "",
      };
      updateAppnameMapping(data);
    }
    currentRow.isEditing = false;
  }

  function togglePaxbot() {
    paxbotOpen = !paxbotOpen;
  }

  function getTop10WastefulApps(rows) {
    // Calculate the waste for each app
    rows.forEach((row) => {
      row.waste = (row.totalLicences - row.users) * row.cost;
    });

    // Sort the rows by waste in descending order
    const sortedRows = rows.sort((a, b) => b.waste - a.waste);

    // Select the top 10 entries
    const top10Rows = sortedRows.slice(0, 10);

    // Calculate the sum of waste of the top 10 entries
    const totalWaste = top10Rows.reduce((sum, row) => sum + row.waste, 0);

    return totalWaste;
  }

  function validateInput(value) {
    if (isNaN(value) || value.trim() === "") {
      return "Please enter a valid number";
    } else {
      return "";
    }
  }

  function addAppname() {
    appnameOpenModal = false;
    rows = rows.map((row) =>
      row.id === rowId ? { ...row, clearname: appname } : row
    );
  }

  function addLicences() {
    errorMessageLicences = validateInput(totalLicenses);
    if (errorMessageLicences) {
      return;
    }
    licencesOpenModal = false;
    rows = rows.map((row) => {
      if (row.id === rowId) {
        return { ...row, totalLicenses: totalLicenses };
      }
      return row;
    });
  }

  function addCostUserYear() {
    errorMessageCostUserYear = validateInput(costUserYear);
    if (errorMessageCostUserYear) {
      return;
    }
    costUserYearOpenModal = false;
    rows = rows.map((row) =>
      row.id === rowId ? { ...row, costPerLicense: costUserYear } : row
    );
  }

  function addTypeChange(id, newType) {
    type = newType;
    rowId = id;
    const row = rows.find((r) => r.id === rowId);
    if (row) {
      row.subscriptionType = newType;
      rows = [...rows];
    }
  }

  function toggleEdit(row) {
    row.isEditing = !row.isEditing;
    rows = [...rows];
  }

  onMount(() => {
    getRows();
  });
</script>

<Header section="License Checker" breadcrumb="Overview">
  <!-- <Button
    text="Report"
    kind="secondary"
    icon={DOWNLOAD_ICON}
    iconLeft={true}
  /> -->
</Header>
<SectionWrapper>
  <main slot="main">
    {#if loading}
      <DataTableSkeleton
        rows={10}
        {headers}
        showToolbar={true}
        showHeader={false}
      />
    {:else}
      <div class="table_wrapper">
        <DataTable
          batchSelection
          sortable
          sortKey={defaultSort.key}
          sortDirection={defaultSort.order}
          {pageSize}
          {page}
          {headers}
          {rows}
          bind:selectedRowIds
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch shouldFilterRows bind:rows persistent />
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:cell let:row>
            {#if cell.key === "totalCostPerYear"}
              {Math.round(cell.value).toLocaleString()} $
            {:else if cell.key === "costPerLicense"}
              {#if row.isEditing}
                <Button
                  variant="primary"
                  text={row.costPerLicense === 0
                    ? "Define"
                    : row.costPerLicense}
                  rounded={true}
                  on:click={() => {
                    rowId = row.id;
                    costUserYear = row.costPerLicense;
                    costUserYearOpenModal = true;
                  }}
                />
              {:else}
                {Math.round(cell.value).toLocaleString()} $
              {/if}
            {:else if cell.key === "wastePerYear"}
              {Math.round(cell.value).toLocaleString()} $
              <!-- 
          BUTTON TO EDIT CLEARNAME COMMENTED WHILE THE BACKEND IS BEEN FIXED 
          -->
              <!-- {:else if cell.key === "clearname" && row.isEditing}
          <Button
            variant="primary"
            rounded={true}
            text={row.clearname ?? "Define"}
            on:click={() => {
              rowId = row.id;
              appname = row.clearname;
              appnameOpenModal = true;
            }}
          /> -->
            {:else if cell.key === "totalLicenses" && row.isEditing}
              <Button
                variant="primary"
                rounded={true}
                text={row.totalLicenses === "" ? "Define" : row.totalLicenses}
                on:click={() => {
                  rowId = row.id;
                  totalLicenses = row.totalLicenses;
                  licencesOpenModal = true;
                }}
              />
            {:else if cell.key === "subscriptionType" && row.isEditing}
              <Select
                id="select-type{row.id}"
                variant="orange"
                options={[
                  { name: "Monthly", value: "Monthly" },
                  { name: "Yearly", value: "Yearly" },
                ]}
                placeholder={row.subscriptionType == ""
                  ? "Select"
                  : row.subscriptionType}
                on:change={(e) => addTypeChange(row.id, e.target.value)}
              />
            {:else if cell.key === "usageScore"}
              <div class="rating_wrapper">
                <RatingPoint filled={row.usageScore * 100 > 0} />
                <RatingPoint filled={row.usageScore * 100 > 20} />
                <RatingPoint filled={row.usageScore * 100 > 40} />
                <RatingPoint filled={row.usageScore * 100 > 60} />
                <RatingPoint filled={row.usageScore * 100 > 80} />
              </div>
            {:else if cell.key === "wastePerYear"}
              {cell.value} $
            {:else if cell.key === "edit"}
              <div class="edit">
                <Button
                  icon={row.isEditing ? SAVE_ICON : EDIT_ICON}
                  on:click={() => {
                    rowId = row.id;
                    if (row.isEditing) {
                      saveAppnameMapping();
                    } else {
                      toggleEdit(row);
                    }
                  }}
                  size="small"
                />
              </div>
            {:else if cell.key === "departments"}
              <div class="departments">
                {#each row.departments.sort( (a, b) => a.localeCompare(b) ) as department}
                  <TechnologyRecommendation
                    text={department}
                    color="#f2f2f2"
                    textColor="#1c1c20"
                  />
                {/each}
              </div>
            {:else}
              {cell.value}
            {/if}
          </svelte:fragment>
        </DataTable>
      </div>
      <Pagination
        bind:pageSize
        bind:page
        totalItems={rows.length}
        pageSizes={[15, 25, 50]}
      />
    {/if}
  </main>
  <div slot="menu" class="menu">
    <!-- <PaxbotSidemenu
      bind:paxbotOpen
      text="Allow Paxbot to identify applications with high savings potential."
    >
      {#if paxbotOpen !== true}
        <Button
          text="Start"
          kind="outline"
          on:click={togglePaxbot}
          disabled={true}
        />
      {:else}
        <Button
          text="Close"
          kind="outline"
          on:click={togglePaxbot}
        />
      {/if}
    </PaxbotSidemenu> -->
    <Accordion heading="Information" open={true}>
      <div class="kpi_wrapper">
        <SideKPI
          name="Potential Savings"
          showIcon={true}
          icon="cash"
          value={loading ? "..." : totalWaste}
          unit={loading ? "" : "$"}
        />
      </div>
    </Accordion>
  </div>
</SectionWrapper>

<PaxbotBottomRight heading="AI-Assistant (Paxbot)" bind:paxbotOpen>
  <div class="text">
    I selected the <span class="bold">10</span> Applications with the hugest
    savings potentials. If you optimize all of the licenses, you can save up to
    <span class="bold">{paxbotWaste} $</span> per year.
  </div>
  <div class="button_wrapper">
    <Button
      kind="outline"
      text="Download Report"
      icon={DOWNLOAD_DARK_ICON}
      iconLeft={true}
    />
  </div>
</PaxbotBottomRight>

<Modal
  size="lg"
  open={appnameOpenModal}
  modalHeading="Define Application Name"
  primaryButtonText="Define"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => {
    appnameOpenModal = false;
  }}
  on:open
  on:close={() => {
    appnameOpenModal = false;
  }}
  on:submit={addAppname}
>
  <TextInput labelText="Application Name" bind:value={appname} />
</Modal>

<Modal
  size="lg"
  open={licencesOpenModal}
  preventCloseOnClickOutside
  modalHeading="Define number of Licences"
  primaryButtonText="Define"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    licencesOpenModal = false;
  }}
  on:open
  on:close={() => {
    licencesOpenModal = false;
  }}
  on:submit={addLicences}
>
  <TextInput
    labelText="Licences number"
    bind:value={totalLicenses}
    on:input={() => validateInput(totalLicenses)}
  />
  {#if errorMessageLicences}
    <p style="color: red;">{errorMessageLicences}</p>
  {/if}
</Modal>

<Modal
  size="lg"
  open={costUserYearOpenModal}
  modalHeading="Define Cost per User per Year"
  primaryButtonText="Define"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => {
    costUserYearOpenModal = false;
  }}
  on:open
  on:close={() => {
    costUserYearOpenModal = false;
  }}
  on:submit={addCostUserYear}
>
  <TextInput
    labelText="Cost/User/year"
    bind:value={costUserYear}
    on:input={() => (errorMessageCostUserYear = validateInput(costUserYear))}
  />
  {#if errorMessageCostUserYear}
    <p style="color: red;">{errorMessageCostUserYear}</p>
  {/if}
</Modal>

<style>
  .menu {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  main {
    width: 100%;
  }

  .kpi_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .text {
    line-height: 1.2rem;
  }

  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    padding-top: 1.6rem;
    padding-bottom: 1rem;
  }

  .rating_wrapper {
    display: flex;
    gap: 0.2rem;
  }

  .edit {
    height: 2rem;
    width: 2rem;
    background-color: var(--pax-black);
    border-radius: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .departments {
    display: flex;
    gap: 0.5rem;
  }

  .table_wrapper {
    width: 100%;
    overflow-x: auto;
  }
</style>
